import { render } from "./Report.vue?vue&type=template&id=40588ccd&scoped=true"
import script from "./Report.vue?vue&type=script&lang=ts"
export * from "./Report.vue?vue&type=script&lang=ts"

import "./Report.vue?vue&type=style&index=0&id=40588ccd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40588ccd"

export default script